import { AuthUseCaseInterface } from 'application/usecases/AuthUseCase';
import { ChatUseCase } from 'application/usecases/ChatUseCase';
import { NotifyUseCaseInterface } from 'application/usecases/NotifyUseCase';
import { UserStorageUseCaseInterface } from 'application/usecases/UserStorageUseCase';
import { UserUseCaseInterface } from 'application/usecases/UserUseCase';
import { Outlet } from 'react-router-dom';
import MenuHeader from './menu-header';

interface props {
    userStorageUseCase: UserStorageUseCaseInterface;
    authUseCase: AuthUseCaseInterface;
    userUseCase: UserUseCaseInterface;
    chatUseCase: ChatUseCase;
    notifyUseCase: NotifyUseCaseInterface;
}

export const PrivateRoute = (props: props) => {
    return (
        <MenuHeader {...props}>
            <Outlet />
        </MenuHeader>
    );
};
